import { toast } from "react-toastify";

export function toPascalCase(str) {
  return str
    .split(/[-\s]/) // Split on both hyphens and spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter and lowercase the rest
    .join(""); // Join all the words together
}

export function formatNumberWithSuffix(n) {
  if (n >= 1000000) {
    return (
      new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(
        n / 1000000
      ) + "M"
    );
  } else if (n >= 1000) {
    return (
      new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(
        n / 1000
      ) + "k"
    );
  } else {
    return new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
      n
    ); // For numbers less than 1000
  }
}

export function getInitials(...arr) {
  return arr
    .filter(Boolean)
    .map((name) => name[0].toUpperCase())
    .join("");
}

const toastStyle = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeButton: false,
  style: {
    minHeight: "40px",
    padding: "8px",
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
  },
};

export function showSuccessToast(message) {
  // console.log("message: success message", message);
  toast.success(message, toastStyle);
}

export function showErrorToast(message) {
  console.log("message: error message", message);
  toast.error(message, toastStyle);
}
